import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { isKnownGuid, getGuidLabel } from 'customer-data-objects/property/knownGuidUtils';
import UITextInput from 'UIComponents/input/UITextInput';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import InternalValueTooltip from './externalOptions/InternalValueTooltip';

const PropertyInputKnownGuid = props => {
  const {
    value,
    objectTypeId,
    property,
    inputRef
  } = props;
  const displayValue = useMemo(() => {
    if (!value || !isKnownGuid(value)) {
      return value || '';
    }

    return getGuidLabel(value);
  }, [value]);

  const input = /*#__PURE__*/_jsx(UITextInput, Object.assign({}, getTransferrableProps(props), {
    readOnly: true,
    inputRef: inputRef,
    value: displayValue
  }));

  if (!value || !isKnownGuid(value)) {
    return input;
  }

  return /*#__PURE__*/_jsx(InternalValueTooltip, {
    internalValue: value,
    objectTypeId: objectTypeId,
    property: property,
    children: input
  });
};

export default /*#__PURE__*/memo(PropertyInputKnownGuid);